import * as customerPortalApi from '@kk/api/modules/customerPortal';
import { fetchWithCredentials, headers } from '#/api/options';
import { ClientConfig } from '#/client-config';

customerPortalApi.defaults.baseUrl = `${ClientConfig.apiUrl}/kundeportalen-orchestration/v1`;
customerPortalApi.defaults.headers = headers;
customerPortalApi.defaults.credentials = 'include';
customerPortalApi.defaults.fetch = fetchWithCredentials;

export default customerPortalApi;
